export enum FortigateProvisionState {
    input,
    loadingFields,
    review,
    provisioning,
    finished
}
